import React, { useState, useCallback } from 'react';
import { Check } from 'lucide-react';
import Calendar from './CalendarFrame';
import moment from 'moment';
import { AiOutlineCalendar } from "react-icons/ai";

const MAX_PEOPLE_PER_DATE = 4;

const INITIAL_FORM_DATA = {
  fullName: '',
  // age: '',
  mobileNo: '',
  emailId: '',
  profession: '',
  eduQualif: '',
  orgName: '',
  // jobTitle: '',
  address: '',
  numberOfPeople: '1'
};

const formatDateString = (date) => moment(date).format('YYYY-MM-DD');
const formatDisplayDate = (date) => moment(date).format('dddd, MMMM Do YYYY');

const sanitizeInput = (name, value) => {
  if (typeof value !== 'string') return value;

  switch (name) {
    case 'mobileNo':
      return value.replace(/\D/g, '').slice(0, 10);
    // case 'age':
    //   return value.replace(/\D/g, '').slice(0, 2);
    default:
      return value.trimStart();  // Starting spaces hata diye, beech mein space allow hai
  }
};

const BookingForm = ({
  selectedDate,
  onSubmit,
  onClose,
  getBookingsCount,
  currentDate,
  handleDateSelect,
  handleMonthChange,
  isDateAvailable
}) => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [show, setShow] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case 'fullName':
        return /^[A-Za-z\s]{3,}$/.test(value) ? '' : 'Enter valid full name';
      // case 'age':
      //   return value === '' ? 'Enter Age' : (value >= 1 && value <= 99) ? '' : 'Age must be 1-99';
      case 'mobileNo':
        return /^\d{10}$/.test(value) ? '' : 'Enter 10-digit mobile number';
      case 'emailId':
        return value === '' ? 'Enter Email ID' : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email';
      case 'address':
        return value.length >= 5 ? '' : 'Address is too short';
      default:
        return '';
    }
  };

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(name, value);

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: validateField(name, sanitizedValue)
    }));
  }, []);

  const handleSubmit = useCallback(() => {
    let hasErrors = false;
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) hasErrors = true;
      newErrors[key] = error;
    });

    setFormErrors(newErrors);

    if (hasErrors) return;

    onSubmit(formData);
    setFormData(INITIAL_FORM_DATA);
  }, [formData, onSubmit]);

  const availableSlots = selectedDate
    ? MAX_PEOPLE_PER_DATE - getBookingsCount(formatDateString(selectedDate))
    : 0;
  console.log("availableSlots", availableSlots);

  const isToday = moment(selectedDate).isSame(moment(), "day");
  const finalSlots = isToday && moment().hour() >= 10 ? 0 : availableSlots;
  console.log("finalSlots", finalSlots);

  return (
    <div className="container py-3">
      <form className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Full Name <span className="text-danger">*</span></label>
          <input
            type="text"
            name="fullName"
            className={`form-control ${formErrors.fullName ? 'is-invalid' : ''}`}
            value={formData.fullName}
            placeholder='Full Name'
            onChange={handleInputChange}
            required
          />
          {formErrors.fullName && <div className="invalid-feedback">{formErrors.fullName}</div>}
        </div>

        {/* <div className="col-md-6">
          <label className="form-label">Age <span className="text-danger">*</span></label>
          <input
            type="number"
            name="age"
            className={`form-control ${formErrors.age ? 'is-invalid' : ''}`}
            value={formData.age}
            placeholder='Age'
            onChange={handleInputChange}
            min="1"
            max="99"
          />
          {formErrors.age && <div className="invalid-feedback">{formErrors.age}</div>}
        </div> */}

        <div className="col-md-6">
          <label className="form-label">Mobile No <span className="text-danger">*</span></label>
          <input
            type="tel"
            name="mobileNo"
            placeholder='Mobile No'
            className={`form-control ${formErrors.mobileNo ? 'is-invalid' : ''}`}
            value={formData.mobileNo}
            onChange={handleInputChange}
            required
          />
          {formErrors.mobileNo && <div className="invalid-feedback">{formErrors.mobileNo}</div>}
        </div>

        <div className="col-md-6">
          <label className="form-label">Email ID <span className="text-danger">*</span></label>
          <input
            type="email"
            name="emailId"
            placeholder='Email ID'
            className={`form-control ${formErrors.emailId ? 'is-invalid' : ''}`}
            value={formData.emailId}
            onChange={handleInputChange}
          />
          {formErrors.emailId && <div className="invalid-feedback">{formErrors.emailId}</div>}
        </div>

        <div className="col-md-6">
          <label className="form-label">Profession</label>
          <input
            type="text"
            name="profession"
            placeholder='Profession'
            className={`form-control`}
            value={formData.profession}
            onChange={handleInputChange}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label">Education Qualification</label>
          <input
            type="text"
            name="eduQualif"
            placeholder='Education Qualification'
            className={`form-control`}
            value={formData.eduQualif}
            onChange={handleInputChange}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label">Organisation Name</label>
          <input
            type="text"
            name="orgName"
            placeholder='Organisation Name'
            className={`form-control`}
            value={formData.orgName}
            onChange={handleInputChange}
          />
        </div>

        {/* <div className="col-md-6">
          <label className="form-label">Job Title</label>
          <input
            type="text"
            name="jobTitle"
            placeholder='Job Title'
            className={`form-control`}
            value={formData.jobTitle}
            onChange={handleInputChange}
          />
        </div> */}

        <div className="col-12">
          <label className="form-label">Full Address <span className="text-danger"><span className="text-danger">*</span></span></label>
          <textarea
            name="address"
            placeholder='Full Address'
            className={`form-control ${formErrors.address ? 'is-invalid' : ''}`}
            rows="3"
            value={formData.address}
            onChange={handleInputChange}
            required
          />
          {formErrors.address && <div className="invalid-feedback">{formErrors.address}</div>}
        </div>

        <div className="col-md-6">
          <label className="form-label d-block">&nbsp;</label>
          <button
            type="button"
            className={`btn w-100 ${show ? 'btn-danger' : 'btn-outline-secondary'}`}
            onClick={() => setShow(!show)}
          >
            {show ? 'Close Calendar' : (
              <span className="d-flex justify-content-between align-items-center">
                <span>Select Date</span><AiOutlineCalendar size={20} />
              </span>
            )}
          </button>
        </div>

        {show && (
          <>
            <div className="col-12">
              <div className="border p-3 bg-light rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <strong>{selectedDate && formatDisplayDate(selectedDate)}</strong><br />
                    <small>{finalSlots} slots available</small>
                  </div>
                  <div className={`fw-bold ${finalSlots > 0 ? 'text-success' : 'text-danger'}`}>
                    {finalSlots > 0 ? <><Check size={16} /> Available</> : 'Not Available'}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <Calendar
                currentDate={currentDate}
                selectedDate={selectedDate}
                onDateSelect={handleDateSelect}
                onMonthChange={handleMonthChange}
                getBookingsCount={getBookingsCount}
                isDateAvailable={isDateAvailable}
              />
            </div>
          </>
        )}

        <div className="col-md-6">
          <label className="form-label">Number of Participants (including you) <span className="text-danger">*</span></label>
          <select
            name="numberOfPeople"
            value={formData.numberOfPeople}
            onChange={handleInputChange}
            className="form-select"
            required
          >
            {Array.from({ length: 4 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>{num}</option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <button
            type="button"
            onClick={handleSubmit}
            className="btn btn-warning w-100 fw-bold"
          >
            Confirm Booking
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookingForm;
